import { z } from "zod";

const label = z
  .string()
  .trim()
  .toLowerCase()
  .min(1)
  .max(200)
  .regex(/^[a-z0-9]+(?:-[a-z0-9]+)*$/);

/** Campaign labels only: never retain the landing URL or arbitrary query values. */
export const paidAttributionSchema = z.object({
  utm_source: z
    .string()
    .trim()
    .toLowerCase()
    .pipe(z.enum(["meta", "tiktok"])),
  utm_medium: z.string().trim().toLowerCase().pipe(z.literal("paid")),
  utm_campaign: label.refine((value) => {
    if (!/^[a-z0-9]+(?:-[a-z0-9]+)+-\d{8}$/.test(value)) return false;
    const date = value.slice(-8);
    const isoDate = `${date.slice(0, 4)}-${date.slice(4, 6)}-${date.slice(6)}`;
    const parsed = new Date(`${isoDate}T00:00:00Z`);
    return (
      Number.isFinite(parsed.getTime()) &&
      parsed.toISOString().slice(0, 10) === isoDate
    );
  }),
  utm_content: label,
});
export type PaidAttribution = z.infer<typeof paidAttributionSchema>;

/** Parse a complete four-label campaign; missing, duplicated or invalid labels yield no attribution. */
export function paidAttributionFromSearch(
  search: string,
): PaidAttribution | undefined {
  const params = new URLSearchParams(search);
  const input = Object.fromEntries(
    Object.keys(paidAttributionSchema.shape).map((key) => [
      key,
      params.getAll(key).length === 1 ? params.get(key) : undefined,
    ]),
  );
  const result = paidAttributionSchema.safeParse(input);
  return result.success ? result.data : undefined;
}
